//Libraries
import React from "react";
import { Row } from "react-bootstrap";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import fileDownload from "js-file-download";

//Components
import LoadingModal from "../CustomUIComponents/LoadingModal/LoadingModal";
import ExternalReconciliation from "./ExternalReconciliation";
import UserNotification from "../CustomUIComponents/UserNotification/UserNotification";

//Actions
import {
  getExternalReconciliationAction,
  markExternalReconciliationStatusAction,
  downloadExternalReconciliationAction,
} from "./ExternalReconciliationAction";

//Constants
import { OPERATION_STATUS } from "../../config/axios.init";

//Strings
import { Strings } from "../../resources/i18n/i18n";

//Utility
import Utility from "../../utils/Utility";

class ExternalReconciliationContainer extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      showLoader: false,
      errorMessage: "",
      isError: false,
      externalReconciliationData: [],
      numberOfPages: 0,
    };
  }

  submitInputs = (requestData) => {
    this.setState({ showLoader: true });
    markExternalReconciliationStatusAction(requestData, (response) => {
      if (response.status === OPERATION_STATUS.SUCCESS) {
        this.setState(
          {
            errorMessage: "",
            showLoader: false,
          },
          () => {
            this.handleOnClickSearchFilter(this.state.prevRequestData);
          }
        );
      } else {
        this.setState({
          errorMessage: response.error.message,
          showLoader: false,
          isError: true,
        });
      }
    });
  };

  handleOnClickSearchFilter = (requestData) => {
    this.setState({
      showLoader: true,
      prevRequestData: requestData,
    });
    getExternalReconciliationAction(requestData, (response) => {
      if (response.status === OPERATION_STATUS.SUCCESS) {
        this.setState({
          externalReconciliationData: response.data.data.erl,
          numberOfPages: response.data.data.np,
          maxDays: response.data.data.md,
          showLoader: false,
          errorMessage: "",
        });
      } else {
        this.setState({
          externalReconciliationData: [],
          errorMessage: response.error.message,
          showLoader: false,
        });
      }
    });
  };

  downloadReports = (url, searchFilterObject, fileType, isDownloadFile) => {
    this.setState({ showLoader: true, isError: false });
    downloadExternalReconciliationAction(
      url,
      searchFilterObject,
      (response) => {
        if (response.status === OPERATION_STATUS.SUCCESS) {
          if (!isDownloadFile) {
            this.setState({
              showLoader: false,
              isError: true,
              level: "success",
              errorMessage: Strings("pdfDownload"),
            });
          } else if (Utility.checkBlobTypeForFileDownload(response.data.type)) {
            fileDownload(
              response.data,
              Strings("EXTERNAL_RECONCILIATION") +
                "-" +
                Utility.getReportFormattedDateString(
                  Utility.convertDateIntoMiliSeconds(new Date())
                ) +
                Utility.getFileType(fileType)
            );
            this.setState({
              errorMessage: "",
              showLoader: false,
              isError: false,
            });
          } else {
            this.setState({
              showLoader: false,
              isError: true,
              level: "error",
              errorMessage: Strings("NoRecordsFound"),
            });
          }
        } else {
          this.setState({
            showLoader: false,
            errorMessage: response.error.message,
          });
        }
      },
      isDownloadFile
    );
  };

  render() {
    return (
      <div>
        <LoadingModal showLoadingModal={this.state.showLoader} />
        {this.state.isError && (
          <UserNotification
            key='Error'
            userNotificationObj={{
              message: this.state.errorMessage,
              level: this.state.level ? this.state.level : "error",
            }}
          />
        )}
        <Row className='heading'>{Strings("EXTERNAL_RECONCILIATION")}</Row>
        <ExternalReconciliation
          numberOfPages={this.state.numberOfPages}
          maxDays={this.state.maxDays}
          externalReconciliationData={this.state.externalReconciliationData}
          submitInputs={this.submitInputs}
          errorMessage={this.state.errorMessage}
          handleOnClickSearchFilter={this.handleOnClickSearchFilter}
          handleDownloadFile={this.downloadReports}
        />
      </div>
    );
  }
}

const mapStateToProps = () => ({}); //NOSONAR

const mapDispatchToProps = (dispatch) => {
  return bindActionCreators({}, dispatch);
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(ExternalReconciliationContainer);
